import { Link } from 'react-router-dom'

export default function ReaderControls({ visible, mangaSlug, mangaTitle, chapterNumber, onCommentsToggle, commentsOpen }) {
  return (
    <div className="fixed top-0 left-0 right-0 z-50">
      {/* Sliding bar */}
      <div
        className="transition-transform duration-200 reader-nav"
        style={{
          background: 'rgba(15,15,15,0.97)',
          backdropFilter: 'blur(12px)',
          borderBottom: '1px solid #2a2a2a',
          transform: visible ? 'translateY(0)' : 'translateY(-100%)',
        }}
      >
        <div className="max-w-3xl mx-auto px-4 h-12 flex items-center gap-4 pr-16">
          <Link to={`/manga/${mangaSlug}`} className="text-sm truncate max-w-[140px] sm:max-w-[240px]">
            {mangaTitle}
          </Link>

          <span style={{ color: '#333' }}>/</span>

          <span className="text-sm font-medium truncate" style={{ color: '#e8e8e8' }}>
            Глава {chapterNumber}
          </span>

          <div className="flex-1" />

          <button
            onClick={onCommentsToggle}
            className={`flex items-center gap-1.5 text-sm transition-colors ${commentsOpen ? 'reader-nav-active' : ''}`}
          >
            <span>💬</span>
            <span>Обсудить</span>
          </button>
        </div>
      </div>

      {/* ✕ — always visible, aligned to the same max-w-3xl grid */}
      <div className="absolute top-0 left-0 right-0 h-12 pointer-events-none">
        <div className="max-w-3xl mx-auto px-2 h-12 flex items-center justify-end">
          <Link
            to={`/manga/${mangaSlug}`}
            onClick={() => window.scrollTo(0, 0)}
            className="reader-btn pointer-events-auto w-9 h-9 flex items-center justify-center rounded-full text-sm"
            title="Выйти из читалки"
          >
            ✕
          </Link>
        </div>
      </div>
    </div>
  )
}
